export class EmptyDomainAuResponseError extends Error {
  constructor() {
    super('Could not find any results for the given query.');
  }
}
